import { Routes } from '@angular/router';
import { LanguageSettings } from './lang/lang';
import { SettingsLayout } from './settings-layout/settings-layout';
import { Settings } from './settings/settings';

/**
 * The settings screens, spread into each add-in's route table. A function
 * rather than an array because the host's own settings pages have to sit under
 * the shared layout, which renders the back link.
 */
export function settingsRoutes(children: Routes = []): Routes {
  return [
    {
      path: 'settings',
      component: SettingsLayout,
      data: { hideTenantBar: true },
      children: [
        {
          path: '',
          component: Settings
        },
        {
          path: 'lang',
          component: LanguageSettings
        },
        ...children
      ]
    }
  ];
}
